import React, { useState } from 'react'
import PropTypes from 'prop-types'

// Components
import { BUTTON_THEME } from '@st-operations/uikit/src/v2'
import TaxonomyForm from './form'

// Styles
import './styles.scss'

// local
import { FIELDS, INITIAL_STATE } from './constants'

const CreateTaxonomy = ({ onToggle }) => {
  const [error, setError] = useState(null)
  const [needMappingIds, setNeedMappingIds] = useState(null)
  const [values, setValues] = useState(INITIAL_STATE)
  const [hasChanges, setHasChanges] = useState(false)

  const handleChange = (field, value) => {
    setValues((v) => ({ ...v, [field.name]: value }))
    setHasChanges(true)
  }

  const handleSave = () => {
    const requestBody = {
      name: values.name,
      slug: values.slug,
      is_branded: values.is_branded,
      distribution: values.distribution,
    }
    if (values.segments.length > 0) {
      const { segments, name_separator, id_sets } = values
      requestBody.new_segments_config = {
        segments,
        name_separator,
        id_sets,
      }
    }
    window._api.post(`/taxonomies/`, requestBody, (err, item) => {
      if (err) {
        toast.error(err.message)
      } else {
        toast.success('Creation successful!!!')
        setHasChanges(false)
        window._history.push(`/taxonomies/${item._id}`)
      }
    })
  }

  const headerActions = [
    {
      children: 'Exit',
      onClick: onToggle,
      theme: BUTTON_THEME.GHOST,
    },
    {
      children: 'Save',
      onClick: handleSave,
      disabled: !hasChanges,
    },
  ]

  return (
    <>
      <If condition={error}>
        <p>{error.message}</p>
      </If>
      <div id="create-taxonomy-page" className="taxonomy">
        <TaxonomyForm
          handleChange={handleChange}
          headerActions={headerActions}
          title="Create Taxonomy"
          fields={FIELDS}
          values={values}
          distributions={values.distribution}
          setError={setError}
          setNeedMappingIds={setNeedMappingIds}
          needMappingIds={needMappingIds}
        />
      </div>
    </>
  )
}

CreateTaxonomy.propTypes = {
  onToggle: PropTypes.func.isRequired,
}
export default CreateTaxonomy
